import { Ortak } from './../../../../providers/ortak';
import { BllOrtak } from './../../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the GelirgidereklePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-gelirgiderekle',
  templateUrl: 'gelirgiderekle.html',
})
export class GelirgidereklePage {
  kayit:any={};
  KayitVw:any={};

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public viewCtrl:ViewController,
     public navParams: NavParams) {
    if (navParams.get("KayitVw") != null) {
      this.KayitVw = navParams.get("KayitVw");
      var data = new FormData();
      data.append("Kasa_id", this.KayitVw.ID);
      this.bllOrtak.islem(data, "AciklamaGetirByID", "", false).then(a => {
        var Sonuc = <any>a;
        this.kayit = Sonuc.SonucObject;
       
       
      }
      )
    }
  }

  ionViewDidLoad() {

  }
  boslukKontrol() {
    var mesaj = "";
    
    if (this.kayit.Name == null || this.kayit.Name == "") {
      mesaj = mesaj + "Lütfen Durum adını giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kaydet() {

    var formData = new FormData();
   
    if (this.boslukKontrol()) {
      formData.append("Aciklama_json", JSON.stringify(this.kayit));
     
      this.bllOrtak.islem(formData, "AciklamaEkleGuncelle", "", false).then(a => {
        var sonuc = <any>a;
        if(sonuc.Sonuc==1) this.ortak.showBasicAlert("Başarılı","İşlem Başarılı");
       

      })
    }
    this.cikis();
    }
    cikis()
    {
      this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/gelirgider/gelirgiderekle/gelirgiderekle.ts